/* ==========================================================================
   XOTIC MUSHROOMS — Theme behaviour
   Vanilla JS, no dependencies. Progressive: everything still renders without it.
   ========================================================================== */
(function () {
  "use strict";

  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat)
      : "$" + (cents / 100).toFixed(2);

  /* ---------------- Cart drawer + count ---------------- */
  const drawer = document.querySelector("[data-cart-drawer]");

  function setCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.setAttribute("data-count", count);
    });
  }

  async function refreshCart() {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      const cart = await res.json();
      setCartCount(cart.item_count);
      renderDrawer(cart);
      return cart;
    } catch (e) { console.error("cart refresh failed", e); }
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    const list = drawer.querySelector("[data-cart-items]");
    const foot = drawer.querySelector("[data-cart-subtotal]");
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<div class="x-drawer__empty">Your cart is empty.</div>';
      if (foot) foot.textContent = money(0);
      return;
    }
    list.innerHTML = cart.items.map((it) => `
      <div class="x-drawer__item" data-line-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[^.]+)$/, "_160x$1") : ""}" alt="${it.product_title}">
        <div style="flex:1">
          <div class="x-title" style="font-size:.95rem">${it.product_title}</div>
          ${it.variant_title && it.variant_title !== "Default Title" ? `<div class="x-muted-2" style="font-size:.8rem">${it.variant_title}</div>` : ""}
          <div style="display:flex;justify-content:space-between;align-items:center;margin-top:.4rem">
            <div class="x-muted" style="font-size:.85rem">Qty ${it.quantity}</div>
            <div class="x-title" style="font-size:.9rem">${money(it.final_line_price)}</div>
          </div>
          <button class="x-link-underline" style="font-size:.7rem;margin-top:.3rem;background:none;border:0;padding:0;opacity:.6" data-remove="${it.key}">Remove</button>
        </div>
      </div>`).join("");
    if (foot) foot.textContent = money(cart.total_price);
  }

  function openDrawer() { if (drawer) { drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("is-open"); document.body.style.overflow = ""; } }

  document.addEventListener("click", async (e) => {
    const open = e.target.closest("[data-cart-open]");
    if (open && drawer) { e.preventDefault(); openDrawer(); refreshCart(); }
    if (e.target.closest("[data-cart-close]") || e.target.matches(".x-drawer__overlay")) closeDrawer();
    const rm = e.target.closest("[data-remove]");
    if (rm) {
      await fetch("/cart/change.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: rm.getAttribute("data-remove"), quantity: 0 }),
      });
      refreshCart();
    }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  /* ---------------- Add to cart (intercept product forms) ---------------- */
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest('form[action$="/cart/add"], form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST", headers: { Accept: "application/json" }, body: new FormData(form),
      });
      if (!res.ok) throw new Error("add failed");
      await refreshCart();
      openDrawer();
    } catch (err) {
      console.error(err);
      window.location.href = "/cart";
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener("click", (e) => {
    const step = e.target.closest("[data-qty-step]");
    if (!step) return;
    const wrap = step.closest("[data-qty]");
    const input = wrap.querySelector("input, [data-qty-val]");
    const dir = parseInt(step.getAttribute("data-qty-step"), 10);
    let val = parseInt((input.value || input.textContent || "1"), 10) + dir;
    if (val < 1) val = 1;
    if ("value" in input) input.value = val; else input.textContent = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------- PDP: variant + selling plan selection ---------------- */
  document.querySelectorAll("[data-product-root]").forEach((root) => {
    const data = root.querySelector("[data-product-json]");
    if (!data) return;
    let product;
    try { product = JSON.parse(data.textContent); } catch (e) { return; }

    const variantInput = root.querySelector("[data-variant-id]");
    const priceEl = root.querySelector("[data-price]");
    const compareEl = root.querySelector("[data-compare]");
    const addText = root.querySelector("[data-add-text]");
    const stickyTitle = root.querySelector("[data-sticky-opt]");

    function currentVariant() {
      const id = variantInput && variantInput.value;
      return product.variants.find((v) => String(v.id) === String(id)) || product.variants[0];
    }
    function sellingPlanSelected() {
      const sp = root.querySelector('[data-selling-plan]:checked');
      return sp ? sp.value : "";
    }
    function update() {
      const v = currentVariant();
      if (!v) return;
      const sp = sellingPlanSelected();
      let price = v.price, compare = v.compare_at_price;
      if (sp) {
        const alloc = (v.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === String(sp));
        if (alloc) { compare = v.price; price = alloc.per_delivery_price || alloc.price; }
      }
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) {
        if (compare && compare > price) { compareEl.textContent = money(compare); compareEl.style.display = ""; }
        else { compareEl.style.display = "none"; }
      }
      const isPre = root.dataset.preorder === "true";
      if (addText) addText.textContent = !v.available ? "Sold out" : (isPre ? "Pre-order" : "Add to cart");
      const addBtn = root.querySelector("[data-add-btn]");
      if (addBtn) addBtn.disabled = !v.available;
      const addTotal = root.querySelector("[data-add-total]");
      const qtyInput = root.querySelector('[name="quantity"]');
      const qv = qtyInput ? Math.max(1, parseInt(qtyInput.value || "1", 10)) : 1;
      if (addTotal) addTotal.textContent = v.available ? " · " + money(price * qv) : "";
      if (stickyTitle) stickyTitle.textContent = (v.title && v.title !== "Default Title" ? v.title : product.title);
    }

    root.querySelectorAll("[data-variant-option]").forEach((el) => {
      el.addEventListener("change", () => {
        // map selected radio/select to a variant id
        const opts = Array.from(root.querySelectorAll("[data-variant-option]:checked, select[data-variant-option]"))
          .map((o) => o.value);
        const match = product.variants.find((v) =>
          opts.length ? opts.every((o, i) => v.options.includes(o) || v.title === o || String(v.id) === o) : true
        );
        if (match && variantInput) variantInput.value = match.id;
        // visual active state for button-style options
        root.querySelectorAll("[data-variant-option]").forEach((o) => {
          const lbl = o.closest("label");
          if (lbl) lbl.classList.toggle("is-active", o.checked);
        });
        update();
      });
    });
    root.querySelectorAll("[data-selling-plan-toggle]").forEach((el) =>
      el.addEventListener("change", () => {
        const box = el.closest(".x-sub"); if (box) box.classList.toggle("is-active", el.checked);
        update();
      })
    );
    const qtyEl = root.querySelector('[name="quantity"]');
    if (qtyEl) qtyEl.addEventListener("change", update);
    update();
  });

  /* ---------------- PDP gallery ---------------- */
  document.querySelectorAll("[data-gallery]").forEach((g) => {
    const main = g.querySelector("[data-gallery-main]");
    g.querySelectorAll("[data-gallery-thumb]").forEach((t) => {
      t.addEventListener("click", () => {
        const src = t.getAttribute("data-src");
        if (main && src) main.src = src;
        g.querySelectorAll("[data-gallery-thumb]").forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
      });
    });
  });

  /* ---------------- Sticky buy bar ---------------- */
  const sticky = document.querySelector("[data-sticky-buy]");
  const anchor = document.querySelector("[data-sticky-anchor]");
  if (sticky && anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(
      ([entry]) => sticky.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    ).observe(anchor);
  }

  /* ---------------- Tab attention (lure visitors back when they switch away) ---------------- */
  (function () {
    var messages = ["Come back! 🍄", "Your mushrooms miss you 🍄", "Don't forget your brain food 🍄"];
    var savedTitle = document.title;
    var index = 0;
    var timer = null;
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        savedTitle = document.title;
        timer = setInterval(function () {
          document.title = messages[index % messages.length];
          index++;
        }, 2000);
      } else {
        if (timer) { clearInterval(timer); timer = null; }
        document.title = savedTitle;
        index = 0;
      }
    });
  })();

  /* ---------------- Init ---------------- */
  document.addEventListener("DOMContentLoaded", () => { refreshCart(); });
})();
